import styled from 'styled-components';
import { RadioFieldGroup, Cell } from '@dexma/ui-components';

export const StyledFieldGroup = styled(RadioFieldGroup)<{ $isLoading: boolean }>`
    display: flex;
    flex-wrap: wrap;
    filter: blur(${({ $isLoading }) => ($isLoading ? 0.3 : 0)}em);

    label:first-child {
        margin-left: 6px;
    }

    label {
        margin-top: 4px !important;
    }
`;

export const StyledSpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const StyledFieldGroupCell = styled(Cell)`
    padding-left: 0px;
`;
